<template>
  <q-page class="container" padding>
    <div class="row title align col-12 text-brand-5 text-weight-bold">
      <p class="text-h6 text-brand-5 text-weight-bold">Produtos Contados</p>
    </div>
    <section class="column">
      <span class="q-mt-sm">Inventário Número: {{ inventario.numero }}</span>
      <span
        class="q-mt-sm"
        v-if="inventario.created_at && inventario.created_at.date"
        >Inventário Criado em:
        {{
          inventario.created_at.date
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/")
        }}</span
      >
      <span v-if="inventario.produtos_conferencia" class="q-mt-sm"
        >Núm. Itens: {{ inventario.produtos_conferencia.length }}
      </span>
      <span v-if="inventario.produtos" class="q-mt-sm"
        >Dif. Total:
        {{
          inventario.produtos.reduce((total, numero) => {
            return total + +numero.preco;
          }, 0)
        }}
      </span>
      <span v-if="inventario.produtos_conferencia" class="q-mt-sm">
        Contado Por:
      </span>
      <span v-if="inventario.produtos_conferencia" class="q-mt-sm">
        Aprovado Por:
      </span>
    </section>

    <div class="container q-mt-xl">
      <div class="row">
        <div class="col-12">
          <table style="width: 100%" border="1">
            <thead>
              <tr role="row">
                <th>Codigo</th>
                <th>Descrição</th>
                <th>Contado Por</th>
                <th>Qtd.</th>
                <th>Qtd. Sistema</th>
                <th>Dif. R$</th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr
                class="border"
                v-for="(conferencia, index) in inventario.produtos"
                :key="index"
                role="row"
              >
                <td class="center">{{ conferencia.codigo }}</td>
                <td class="row justify-center">{{ conferencia.nome }}</td>
                <td class="center">{{ conferencia.nome_usuario }}</td>
                <td class="center">{{ conferencia.amount }}</td>
                <td class="center">{{ conferencia.stocked }}</td>
                <td class="center">R$: {{ conferencia.preco }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
export default {
  setup() {
    const $route = useRoute();
    const store = useStore();
    const $q = useQuasar();
    const id = $route.params.id;
    const inventario = ref("");

    const getDados = async () => {
      store.dispatch("pdt/hiddenHeader", false);

      try {
        const response = await store.dispatch("inventario/getInventario", {
          id: id,
        });

        inventario.value = await response.data.result;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    return {
      inventario,
    };
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}

.table {
  display: table;
  border-collapse: separate;
  border-spacing: 5px;
}

.cell {
  display: table-cell;
  padding: 5px;
  border: 1px solid black;
}
</style>
